module.exports = __webpack_public_path__ + "static/img/areaA-7.4a4321c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-7.png
// module id = 945
// module chunks = 1